module.exports = __webpack_public_path__ + "static/icon-mission.1418216d.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-mission.png
// module id = 291
// module chunks = 2